<template>
    <div class="pane-content">
        <el-row type="flex" class="mt-2 align-center">
            <h5 class="section-header">Communication Activity</h5>
        </el-row>
        <sync-call-mapper
            class="mt-4"
            :model="model"
            :integration-name="integrationName"
            :integration-name-with-casing="integrationNameWithCasing"
            :static-name="staticName"
        />
        <transcription-file-settings
            v-if="isCallEngagementEnabled"
            class="mt-4"
            :model="model"
            :default-file-upload-settings="defaultFileUploadSettings"
        />
        <sync-sms-mapper
            class="mt-4"
            :model="model"
            :integration-name="integrationName"
            :integration-name-with-casing="integrationNameWithCasing"
            :static-name="staticName"
        />
        <sms-file-settings
          v-if="isSmsEngagementEnabled"
          class="mt-4"
          :model="model"
          :default-file-upload-settings="defaultFileUploadSettings"
        />
    </div>
</template>

<script>
import SyncCallMapper from './hubspot/sync-call-mapper.vue'
import SyncSmsMapper from './hubspot/sync-sms-mapper.vue'
import SmsFileSettings from './hubspot/sms-file-settings.vue'
import TranscriptionFileSettings from './hubspot/transcription-file-settings.vue'
import _ from 'lodash'

export default {
    components: {
        SyncCallMapper,
        SyncSmsMapper,
        SmsFileSettings,
        TranscriptionFileSettings,
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationName: {
            type: String,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        statics: {
            type: Object,
            required: false
        },
        defaultMapperSettings: {
          type: Object,
          required: true
        },
        defaultFileUploadSettings: {
          type: Object,
          required: false
        }
    },
    computed: {
        staticName() {
            return this.statics.name || 'Aloware'
        },
        isCallEngagementEnabled() {
          const call_mapper_settings = this.model?.settings?.mapper_settings?.call || []
          const call_engagement_setting = call_mapper_settings.find(setting =>
            setting?.internal_value === 'call.dispatched' && setting?.crm_value === 'engagement'
          )

          return Boolean(call_engagement_setting?.enabled)
        },
        isSmsEngagementEnabled() {
          const sms_mapper_settings = this.model?.settings?.mapper_settings?.sms || []
          const sms_engagement_setting = sms_mapper_settings.find(setting =>
            setting?.internal_value === 'sms.dispatched' && setting?.crm_value === 'engagement'
          )

          return Boolean(sms_engagement_setting?.enabled)
        }
    },
    mounted() {
      // Listen for reset-tab events from root
      this.$root.$on('integration-settings-reset-tab', this.handleResetTab)
    },
    beforeDestroy() {
      // Clean up event listener
      this.$root.$off('integration-settings-reset-tab', this.handleResetTab)
    },
    methods: {
      handleResetTab() {
        this.model.settings.mapper_settings.call = _.cloneDeep(this.defaultMapperSettings.call)
        this.model.settings.mapper_settings.sms = _.cloneDeep(this.defaultMapperSettings.sms)

        // Ensure file_upload_settings exists before resetting
        if (!this.model.settings.file_upload_settings) {
          this.$set(this.model.settings, 'file_upload_settings', {})
        }

        this.$set(this.model.settings.file_upload_settings, 'sms_attachments', _.cloneDeep(this.defaultFileUploadSettings.sms_attachments))

        // Reset transcription attachment upload settings (inside file_upload_settings)
        if (this.defaultFileUploadSettings?.transcription_attachment) {
          this.$set(
            this.model.settings.file_upload_settings,
            'transcription_attachment',
            _.cloneDeep(this.defaultFileUploadSettings.transcription_attachment)
          )
        }

        this.$notify({
          title: `${this.integrationNameWithCasing} Integration`,
          message: 'The Communication Activity tab has been reset to default values',
          type: 'success'
        })
      }
    }
}
</script>
<style scoped>
.pane-content {
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
}

.section-header {
    margin: 0 12px 0 0;
    font-size: 20px;
}

.align-center {
    align-items: center;
}
</style>
